"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import DateControl from "D5Utils/form_fields/DateControl";
import { Fields } from "Constants/objects";
var CALENDAR_NAVIGATOR_CLASS = '.dx-calendar-navigator';
var CALENDAR_MONTH_CLASS = '.dx-calendar-view-month';
var CALENDAR_YEAR_CLASS = '.dx-calendar-view-year';
var CALENDAR_DECADE_CLASS = '.dx-calendar-view-decade';
var CALENDAR_CENTURY_CLASS = '.dx-calendar-view-century';
var CALENDAR_CELLS_CLASS = '.dx-calendar-cell';
var CALENDAR_SELECTED_DAY_CLASS = '.dx-calendar-selected-date';
var CALENDAR_SELECTED_DAY_CLASS_NAME = 'dx-calendar-selected-date';
var CALENDAR_BTN_TODAY_CLASS = '.dx-button-today';

var DateFromToControl =
/*#__PURE__*/
function (_DateControl) {
  _inherits(DateFromToControl, _DateControl);

  function DateFromToControl(props) {
    var _this;

    _classCallCheck(this, DateFromToControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateFromToControl).call(this, props));
    _this.isOpened = true; //flag for first open calendar

    _this.stepUseCalendar = 0; //step clicked on calendar dates (0, 1, 2)

    _this.min = 0;
    _this.max = 0;
    _this.$calendarContent = null;
    _this.displayCustomParam = props.displayCustomParam;
    return _this;
  }

  _createClass(DateFromToControl, [{
    key: "dispose",
    value: function dispose() {
      this.$_element.dxDateBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "_buildControlProps",
    value: function _buildControlProps() {
      var _this2 = this;

      var displayCustomParam = JSON.parse(this.displayCustomParam);
      var dateFrom = displayCustomParam[Fields.DateFrom];
      var dateTo = displayCustomParam[Fields.DateTo];
      var startDateEditorName = "#form-edit-field-".concat(dateFrom);
      var endDateEditorName = "#form-edit-field-".concat(dateTo);
      var isDateFromField = dateFrom === this.dataField;
      return _objectSpread({}, _get(_getPrototypeOf(DateFromToControl.prototype), "_buildControlProps", this).call(this), {
        applyValueMode: 'useButtons',
        showDropDownButton: !isDateFromField,
        onValueChanged: function onValueChanged(e) {
          if (!e.component._popup || !e.component._popup._options.visible) return;
          var startDateIns = $(startDateEditorName).dxDateBox('instance');
          var endDateIns = $(endDateEditorName).dxDateBox('instance');
          startDateIns.option('savedStartDate', e.component.option('startDate'));
          startDateIns.option('savedEndDate', e.component.option('endDate'));
          endDateIns.option('savedStartDate', e.component.option('startDate'));
          endDateIns.option('savedEndDate', e.component.option('endDate'));

          if (typeof _this2.props.onValueChanged === 'function') {
            _this2.props.onValueChanged(e);
          }
        },
        onOpened: function onOpened(e) {
          var startValue = $(startDateEditorName).dxDateBox('instance').option('value');
          var endValue = $(endDateEditorName).dxDateBox('instance').option('value');
          _this2.$calendarContent = e.component.content(); //calendar content in dropdown popup

          _this2.min = e.component.option('savedStartDate');
          _this2.max = e.component.option('savedEndDate');
          _this2.isOpened = true; //flag for first open calendar

          _this2.stepUseCalendar = 0; //step clicked on calendar dates (0, 1, 2)

          if (!_this2.min && !_this2.max) {
            _this2.min = startValue && startValue.length ? startValue.slice(0, 10).split('-').join('') : null;
            _this2.max = endValue && endValue.length ? endValue.slice(0, 10).split('-').join('') : null;
            e.component.option('savedStartDate', _this2.min);
            e.component.option('savedEndDate', _this2.max);
          }

          _this2.setAttributesCalendar();

          _this2.setEventsCalendarElements();

          _this2.setEventsDaysElements();

          _this2.clearSelectedDays();

          _this2.setSelectedDays({
            min: _this2.min,
            max: _this2.max
          });
        }
      });
    }
    /**
     * add events on navigation, months, years, decades elements and today button
     */

  }, {
    key: "setEventsCalendarElements",
    value: function setEventsCalendarElements() {
      var _this3 = this;

      var $calendarNavigationSelectors = this.$calendarContent.find(CALENDAR_NAVIGATOR_CLASS); //navigation elements

      var $calendarMonthsSelectors = $(CALENDAR_YEAR_CLASS, this.$calendarContent).find(CALENDAR_CELLS_CLASS); //months elements

      var $calendarYearsSelectors = $(CALENDAR_DECADE_CLASS, this.$calendarContent).find(CALENDAR_CELLS_CLASS); //years elements

      var $calendarDecadesSelectors = $(CALENDAR_CENTURY_CLASS, this.$calendarContent).find(CALENDAR_CELLS_CLASS); //decades elements

      var selectorsColl = [$calendarNavigationSelectors, $calendarMonthsSelectors, $calendarYearsSelectors, $calendarDecadesSelectors];
      selectorsColl.forEach(function (selector) {
        selector.off('click').on('click', function (event) {
          setTimeout(function () {
            _this3.setAttributesCalendar();

            _this3.setEventsDaysElements();

            _this3.setSelectedDays({
              min: _this3.min,
              max: _this3.max
            });

            _this3.setEventsCalendarElements();
          });
        });
      });
      $(CALENDAR_BTN_TODAY_CLASS).off('mousedown').on('mousedown', function (event) {
        _this3.min = new Date().toJSON().slice(0, 10).replace(/-/g, '');
        _this3.max = _this3.min;

        _this3.setSelectedDays({
          min: _this3.min,
          max: _this3.max
        });

        _this3.clearSelectedDays();
      });
    }
  }, {
    key: "setEventsDaysElements",

    /**
     * set events on days elements
     */
    value: function setEventsDaysElements() {
      var _this4 = this;

      var $calendarDaysSelectors = $(CALENDAR_MONTH_CLASS, this.$calendarContent).find(CALENDAR_CELLS_CLASS); //days elements

      $calendarDaysSelectors.off('click').on('click', function (event) {
        var currentDayValue = Number($(event.currentTarget).attr('data-custom-value'));

        if (_this4.isOpened && !_this4.stepUseCalendar) {
          _this4.min = currentDayValue;
          _this4.max = null;
          _this4.stepUseCalendar = 1;
          _this4.isOpened = false;

          _this4.setAttributesInstance({
            min: _this4.min,
            max: _this4.max
          });

          _this4.clearSelectedDays();

          return;
        }

        if (!_this4.isOpened && _this4.stepUseCalendar === 1) {
          var $targetDay = currentDayValue;
          var $selectedDay = Number($(CALENDAR_SELECTED_DAY_CLASS, _this4.$calendarContent).attr('data-custom-value')) || min;
          _this4.min = Math.min($targetDay, $selectedDay);
          _this4.max = Math.max($targetDay, $selectedDay);
          _this4.stepUseCalendar = 2;

          _this4.setAttributesInstance({
            min: _this4.min,
            max: _this4.max
          });

          setTimeout(function () {
            return _this4.setSelectedDays({
              min: _this4.min,
              max: _this4.max
            });
          });
          return;
        }

        if (!_this4.isOpened && _this4.stepUseCalendar === 2) {
          _this4.min = currentDayValue;
          _this4.max = currentDayValue;
          _this4.stepUseCalendar = 1;

          _this4.setAttributesInstance({
            min: _this4.min,
            max: _this4.max
          });

          _this4.clearSelectedDays();
        }
      });
    }
  }, {
    key: "setAttributesCalendar",

    /**
     * set formatted value of data-value attribute to custom attribute data-custom-value
     * @example 2017-01-11 to 20170111
     */
    value: function setAttributesCalendar() {
      var $calendarDaysSelectors = $(CALENDAR_MONTH_CLASS, this.$calendarContent).find(CALENDAR_CELLS_CLASS); //days elements

      _.each($calendarDaysSelectors, function (day) {
        $(day).attr('data-custom-value', $(day).attr('data-value').split('/').join(''));
      });
    }
  }, {
    key: "clearSelectedDays",

    /**
     * remove CALENDAR_SELECTED_DAY_CLASS in all days elements
     */
    value: function clearSelectedDays() {
      var $selectedDaysSelectors = $(CALENDAR_SELECTED_DAY_CLASS, this.$calendarContent);

      _.each($selectedDaysSelectors, function (day) {
        $(day).removeClass(CALENDAR_SELECTED_DAY_CLASS_NAME);
      });
    }
  }, {
    key: "setSelectedDays",

    /**
     * set CALENDAR_SELECTED_DAY_CLASS for selected days
     * @param {string | null} min (20180121)
     * @param {string | null} max (20190703)
     */
    value: function setSelectedDays(_ref) {
      var min = _ref.min,
          max = _ref.max;

      if (min && max) {
        for (var start = min; start <= max; start++) {
          if (Number(min.toString().slice(-2)) > 31) continue;
          var elem = $(CALENDAR_CELLS_CLASS + "[data-custom-value='" + start + "']");
          if (elem.length) $(elem, this.$calendarContent).addClass(CALENDAR_SELECTED_DAY_CLASS_NAME);
        }
      } else if (min || max) {
        var onlyDate = min ? min : max;

        var _elem = $(CALENDAR_CELLS_CLASS + "[data-custom-value='" + onlyDate + "']");

        if (_elem.length) $(_elem, this.$calendarContent).addClass(CALENDAR_SELECTED_DAY_CLASS_NAME);
      }
    }
  }, {
    key: "setAttributesInstance",

    /**
     * set custom attributes in instance
     * @param {string or null} min (20180121)
     * @param {string or null} max (20190703)
     */
    value: function setAttributesInstance(_ref2) {
      var min = _ref2.min,
          max = _ref2.max;
      if (!min && max) min = max;
      if (min && !max) max = min;
      e.component.option('startDate', min);
      e.component.option('endDate', max);
    }
  }]);

  return DateFromToControl;
}(DateControl);

export { DateFromToControl as default };